import dayjs from 'dayjs';

export const initialTimeSelection = { timeRangeType: 'ALL' };

//for components that accept time range type
export function buildTimeParams(selection) {
  const sel = selection || initialTimeSelection;
  if (sel.timeRangeType !== 'CUSTOM') {
    return { timeRangeType: sel.timeRangeType };
  }
  return {
    timeRangeType: 'CUSTOM',
    startDate: dayjs(sel.startDate).format('YYYY-MM-DD'),
    endDate: dayjs(sel.endDate).format('YYYY-MM-DD'),
  };
}

//for components that accept time range type and granularity
// For Trends component, always use DAY granularity to get daily data
export function buildStatsParams(selection) {
  const sel = selection || initialTimeSelection;
  if (!sel.timeRangeType || sel.timeRangeType === 'ALL') {
    return { timeRangeType: 'ALL', granularity: 'DAY' };
  }

  if (sel.timeRangeType !== 'CUSTOM') {
    // Always use DAY granularity for Trends component
    return { timeRangeType: sel.timeRangeType, granularity: 'DAY' };
  }

  const start = dayjs(sel.startDate);
  const end = dayjs(sel.endDate);
  // Always use DAY granularity for Trends component
  return {
    startDate: start.format('YYYY-MM-DD'),
    endDate: end.format('YYYY-MM-DD'),
    granularity: 'DAY',
  };
}

// Build only startDate/endDate for cards whose APIs accept ONLY dates
export function buildDateRangeParams(selection) {
  const sel = selection || initialTimeSelection;
  //if no time range type selection, or the selection is 'ALL', return an empty object
  if (!sel?.timeRangeType || sel.timeRangeType === 'ALL') {
    // Backend treats no params as ALL; return empty object
    return {};
  }
  //if the selection is 'CUSTOM', return the start and end dates
  if (sel.timeRangeType === 'CUSTOM') {
    return {
      start: `${dayjs(sel.startDate).format('YYYY-MM-DD')}T00:00:00Z`,
      end: `${dayjs(sel.endDate).format('YYYY-MM-DD')}T23:59:59Z`,
    };
  }
  //if the selection is not 'CUSTOM', calculate the "starting point" of the time period based on the time range type (today/this week/this month/this year)
  const now = dayjs();
  let start;
  switch (sel.timeRangeType) {
    case 'TODAY':
      start = now.startOf('day');
      break;
    case 'THIS_WEEK':
      start = now.startOf('week');
      break;
    case 'THIS_MONTH':
      start = now.startOf('month');
      break;
    case 'THIS_YEAR':
      start = now.startOf('year');
      break;
    default:
      start = now.startOf('day');
  }
  return {
    start: `${start.format('YYYY-MM-DD')}T00:00:00Z`,
    end: `${now.format('YYYY-MM-DD')}T23:59:59Z`,
  };
}


